import { useCallback, useEffect, useState } from "react";
import { fetchHomeConfig, type HomePublicConfig } from "../api/home-config";

let cached: HomePublicConfig | null = null;
let pending: Promise<HomePublicConfig> | null = null;
function readConfig() {
  if (!pending)
    pending = fetchHomeConfig().finally(() => {
      pending = null;
    });
  return pending;
}

export function useHomeConfig() {
  const [config, setConfig] = useState(cached);
  const [loading, setLoading] = useState(!cached);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const refresh = () => {
      if (document.hidden) return;
      readConfig()
        .then((next) => {
          cached = next;
          if (active) {
            setConfig((current) => (JSON.stringify(current) === JSON.stringify(next) ? current : next));
            setError(null);
          }
        })
        .catch(() => {
          if (active) setError("首页展示内容暂时无法加载");
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    };
    refresh();
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      active = false;
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [attempt]);
  const retry = useCallback(() => {
    setLoading(true);
    setAttempt((value) => value + 1);
  }, []);
  return { config, loading, error, retry };
}
